export default class NoActivitiesException extends Error {
  constructor(message, routeIdentifier, tripIdentifier) {
    super(message);
    this.routeIdentifier = routeIdentifier;
    this.tripIdentifier = tripIdentifier;
  }
}
